import { Row, Col, Typography } from 'antd';
import PropTypes from 'prop-types';
import { Input, InputNumber } from 'formik-antd';
import { FormInput, Box } from 'atoms';

const { TextArea } = Input;
const { Title } = Typography;

export function LRReceiverDetails({ isEditMode, setDestination }) {
	return (
		<Box backgroundColor="#f5f5f5" padding="1.5rem">
			<div style={{ textAlign: 'center' }}>
				<Title level={4}>Receiver</Title>
			</div>
			<Row>
				<Col lg={24}>
					<FormInput name="receiver_name" label="Name *">
						<Input disabled={!isEditMode} name="receiver_name" placeholder="Receiver" />
					</FormInput>
				</Col>
				<Col lg={24}>
					<FormInput name="receiver_address" label="Address *">
						<TextArea
							disabled={!isEditMode}
							name="receiver_address"
							placeholder="Address"
							maxLength={200}
						/>
					</FormInput>
				</Col>
			</Row>
			<Row>
				<Col span={12}>
					<FormInput name="receiver_pincode" label="Pincode *">
						<InputNumber
							disabled={!isEditMode}
							name="receiver_pincode"
							placeholder="Pincode"
							controls={false}
							precision={0}
							style={{ width: '100%' }}
							onChange={(value) => setDestination(value, 'destination')}
						/>
					</FormInput>
				</Col>
				<Col span={12}>
					<FormInput name="destination_location" label="Destination *">
						<Input
							disabled
							name="destination_location"
							placeholder="Destination"
							style={{ width: '100%' }}
						/>
					</FormInput>
				</Col>
			</Row>
		</Box>
	);
}

LRReceiverDetails.propTypes = {
	isEditMode: PropTypes.bool,
	setDestination: PropTypes.func,
};
